<template>
    <div class="user-data">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-11">
                    <div class="title-row">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="p-title Raleway p-black"><b>Data confirmation</b></p>
                                <p class="Raleway min-med p-dgrey">If you have any questions, email us info@tecknael.se or call us 0731234321.</p>
                            </div>
                        </div>
                    </div>
                    <!-- this code may be overwrite on page UserDat on comment -->

                    <div class="confirm-data">

                        <div class="download-section">
                            <div class="download_item">
                                <a href="#">Print</a>
                                <img src="/img/icon/printer.svg" alt="">
                            </div>
                            <div class="download_item">
                                <a href="#">Download PDF</a>
                                <img src="/img/icon/pdf.svg" alt="">
                            </div>
                        </div>
                        <div class="detail__dash">
                            <div class="main__dashboard">
                                <div class="row">
                                    <div class="col-md-6 brdr-right">
                                        <div class="dashboard__blck left__blck">
                                            <div class="titles">
                                                <p class="Raleway max-max p-black"><b>Customer details</b></p>
                                            </div>
                                            <div class="checked__data">
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Name:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Peter Nordström</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Postnummer:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">132313-5312</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Phone:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">0731234321</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Fakturaadress:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Markvardsgatan 15 113 54 Stockholm</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Fakturaadress:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Markvardsgatan 15 113 54 Stockholm</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Area ID:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">TYR</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Plant ID:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">423432342341432</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="dashboard__blck right_blck">
                                            <div class="titles">
                                                <p class="Raleway max-max  p-black"><b>Contract information</b></p>
                                            </div>
                                            <div class="checked__data">
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Company name:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Peter Nordström</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Org.nummer:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">132313-5312</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Avtalsform:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Fast pris</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Avtalssstart:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">2019-02-15</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Bindninnstid:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">3 manader</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Betalningssatt:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Faktura</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Ovrigt:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">Faktura</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Elpris:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">78.01 öre / kWh incl</p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <p class="p-black min"><b>Manadsavgift:</b></p>
                                                    </div>
                                                    <div class="col-7">
                                                        <p class="min">15.20 kr</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="win__blck">
                        <div class="big_title">
                            <h1 class="p-title p-black mb-0">What is happening now</h1>
                        </div>
                        <div class="content">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                            <hr />
                        </div>
                        <div class="content">
                            <div class="row">
                                <div class="col-md-7">

                                    <h4>Want to try to win Apple Watch?</h4>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                </div>
                                <div class="col-md-5 text-center">
                                    <img src="/img/38-alu-space-sport-black-nc-1up_GEO_RU.png" alt="">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="row justify-content-center btns">
                        <div class="col-md-6">
                            <button class="btn btn-green btn-full">I want to win </button>
                        </div>
                    </div>
                    <!-- End overwrite section -->
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: "DataConfirmation",
    }
</script>
